import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const GlobalScheduleCloseRBAC = {
  pageID: '6607c7212bb0150b32674d153282d50f',
  elementID: {
    View: 'd4bd5dfb87509f98c196e27ce7c56da8',
    Delete: '6940a17f97734ef2cb9055551501cc66',
    Edit: 'd4bd990068509f98c196e27cfff8e0c3',
    Create: 'a78a2a370b734ef2cb9064f79a2848f7',
  },
} as const

export const useGlobalScheduleCloseRBACPage = createUseRBAC(GlobalScheduleCloseRBAC.elementID)
export type UseGlobalScheduleCloseRBACPageType = ReturnType<typeof useGlobalScheduleCloseRBACPage>
